module.exports = __webpack_public_path__ + "static/fileuploader-f383b46f67d6ec53ff034fa8b4cbd454.gif";